module.exports = __webpack_public_path__ + "img/logo_combined.95990b8b.png";